import { render, staticRenderFns } from "./AppWidgetPanel.vue?vue&type=template&id=75a970d2&scoped=true"
import script from "./AppWidgetPanel.vue?vue&type=script&lang=js"
export * from "./AppWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./AppWidgetPanel.vue?vue&type=style&index=0&id=75a970d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a970d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75a970d2')) {
      api.createRecord('75a970d2', component.options)
    } else {
      api.reload('75a970d2', component.options)
    }
    module.hot.accept("./AppWidgetPanel.vue?vue&type=template&id=75a970d2&scoped=true", function () {
      api.rerender('75a970d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/AppWidgetPanel.vue"
export default component.exports